import React, { useMemo } from 'react';

import { NewsletterSubscription } from '@utils/backend-api/newsletters';
import { EmailSettings as EmailSettingsInterface } from '@utils/backend-api/settings';

import EmailSettingsOption from './EmailSettingsOption';
import styles from './styles.module.scss';

const ARTICLE_NOTIFICATION_STATUS_TOPIC = 'topics';
const ARTICLE_NOTIFICATION_STATUS_ALL = 'all';
const ARTICLE_NOTICATION_STATUSES = [
  ARTICLE_NOTIFICATION_STATUS_TOPIC,
  ARTICLE_NOTIFICATION_STATUS_ALL,
];

interface EmailSettingsProps {
  newsletters: NewsletterSubscription[];
  userEmailSettings: EmailSettingsInterface;
}

const EmailSettings = ({ newsletters, userEmailSettings }: EmailSettingsProps) => {
  const emailSettings = useMemo(
    () => [
      {
        accessLevel: 0,
        slug: 'articleNotifications',
        newsletterId: null,
        title: 'Major Articles',
        subheader: 'Get an email each time we publish a major article.',
        isSubscribed: ARTICLE_NOTICATION_STATUSES.includes(userEmailSettings.articleNotifications),
        frequency: null,
      },
      ...newsletters,
    ],
    [newsletters, userEmailSettings.articleNotifications]
  );

  return (
    <div className={styles.emailOptionContainer}>
      {emailSettings.map((option) => (
        <EmailSettingsOption key={option.subheader} {...option} />
      ))}
    </div>
  );
};

export default EmailSettings;
